import { addItemToBasket, extendFormToMap, selectBasketCheckPriceItem, selectBasketList, BASKET_TYPES } from 'containers/OrderDetails/basketSlice'
import { dateToYMDformat, getContractEndDate, toLongDate } from 'utils/date'
import { ReactComponent as Arrow } from 'assets/arrowRight.svg'
import { useDispatch, useSelector } from 'react-redux'
import { getOrderRedirectPath } from 'utils/redirect'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { checkAvailability } from 'rest/urls'
import Popup from 'components/popups/Popup'
import { useEffect, useState } from 'react'
import { POST } from 'rest/request'
import { v7 } from 'uuid'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const NewMagPopup = () => {
  const list = useSelector(selectBasketList)
  const item = findLastEditedElement(list)
  const [isAvailable, setAvailable] = useState(undefined)
  const checkPrice = useSelector(state => selectBasketCheckPriceItem(state, item.identifier))

  const dispatch = useDispatch()
  const { replace } = useHistory()
  const { t, lang } = useTranslation('basket')

  const verifyAvailability = async (placeId, hash) => {
    try {
      const response = await POST(checkAvailability(placeId), { body: { hash } })
      if (typeof response?.isAvailableForRentNow === 'boolean') {
        throw new Error('wrong response')
      } else {
        setAvailable(response.isAvailableForRentNow)
      }
    } catch (err) {
      setAvailable(false)
      console.log(`Error: ${err}`)
    }
  }

  const addNewItem = withTheSameDate => {
    if (!isAvailable) return
    const { id, identifier: _, ok, ...newItem } = item
    const identifier = v7()
    if (!withTheSameDate) {
      const { m, d, gross_price, gross_price_d } = checkPrice?.priceList?.at(-1) || {}
      const date = checkPrice?.start || dateToYMDformat()
      newItem.rangeDate = { m, d }
      newItem.start = date
      newItem.monthlyPrice = gross_price
      newItem.dailyPrice = gross_price_d
      newItem.end = checkPrice?.end || getContractEndDate({ m, d }, date, !!checkPrice?.rentalMonthMinusOneDay)
    }
    newItem.identifier = identifier
    dispatch(addItemToBasket(newItem))
    replace(`/order/${identifier}`)
  }

  const openMap = withDetails => {
    dispatch(extendFormToMap(true))
    setTimeout(() => {
      replace((withDetails && item.placeId)
        ? item?.rentableType === 'parking'
          ? `/map/${item.placeId}`
          : `/mapdetails/${item.placeId}`
        : getOrderRedirectPath())
    })
  }

  useEffect(() => {
    if (item.hash) {
      verifyAvailability(item.placeId, item.hash)
    }
  }, [item.hash, item.placeId])

  return (
    <Popup>
      <div className='popup__newMag'>
        <h2>{t(item?.rentableType === 'parking' ? 'anotherParkingSpace' : `anotherMAG.${type}`)}</h2>

        <div className='popup__header'>{t('sameType')} ({checkPrice.typeName}){isAvailable === false ? <> - <span className='--warning'>{t('notAvailable')}!</span></> : ':'}</div>
        <div
          className='popup__menu'>
          <div
            className={`menu__item group ${isAvailable === true ? '--click' : isAvailable === false ? '--block' : ''}`}
            onClick={() => addNewItem(true)}>
            <div className='item__desc --secFont'>{t('samePeriod')}: {toLongDate(item.start, lang)} → {item.end ? toLongDate(item.end, lang) : '∞'}</div>
            <div className='menu__arrow center'>
              <Arrow />
            </div>
          </div>

          <div
            className={`menu__item group ${isAvailable === true ? '--click' : isAvailable === false ? '--block' : ''}`}
            onClick={() => addNewItem(false)}>
            <div className='item__desc --secFont'>{t('selectAgain')}</div>
            <div className='menu__arrow center'>
              <Arrow />
            </div>
          </div>
        </div>

        <div className='popup__header'>{t('otherOptions')}:</div>
        <div className='popup__menu'>
          <div
            className='menu__item group --click'
            onClick={() => openMap(true)}>
            <div className='item__desc --secFont'>{t('sameYard')}: {checkPrice.placeName}</div>
            <div className='menu__arrow center'>
              <Arrow />
            </div>
          </div>

          <div
            className='menu__item group --click'
            onClick={() => openMap(false)}>
            <div className='item__desc --secFont'>{t('differentYard')}</div>
            <div className='menu__arrow center'>
              <Arrow />
            </div>
          </div>
        </div>
      </div>
    </Popup>
  )
}

const findLastEditedElement = (list) => {
  const identifier = window.location.pathname.includes('order')
    ? window.location.pathname.replace(/^(\/order\/)([^/]+)(.*)$/, '$2')
    : undefined

  if (identifier) {
    const wantedItem = list.find(item => item.identifier === identifier)
    if (wantedItem) return wantedItem
  }

  return list.findLast(item => item.type === BASKET_TYPES.rent)
}

export default NewMagPopup